import React from 'react';
import { motion } from 'framer-motion';
import { HiHeart } from 'react-icons/hi';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-navy-900 to-charcoal-900 text-white py-6 sm:py-8 border-t border-beige-400/20">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-gray-300 flex items-center justify-center gap-2 flex-wrap text-xs sm:text-sm md:text-base">
            <span>© {new Date().getFullYear()} Wajiha Niazi. All rights reserved.</span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-1">
              Built with <HiHeart className="text-red-400 animate-pulse" /> and React
            </span>
          </p>
          <p className="text-xs sm:text-sm text-gray-400 mt-2">
            Full-Stack Software Engineer | Women in Tech Advocate
          </p>
        </motion.div>
      </div>
    </footer>
  );
};
export default Footer;
